export const socialsData = {
    github: 'https://github.com/dhivya910/',
    linkedIn: 'https://www.linkedin.com/in/dhivya-dharshni-s-76355b1a5/',
    instagram: 'https://www.instagram.com/_.dhiivyaa._/',
}